<router-outlet />
<app-cookie-consent-banner />
